import React from 'react';

import { Prompt } from '../components/prompt/prompt';
import SporreskjemaButton from '../components/sporreskjema-button/sporreskjema-button';
import { SvgCardType } from '../components/svg-card/svg-card-types';
import { SporsmalType } from '../types/generated-types';
import { Skjemaside } from '../utils/piwik-utils';
import { CurrentSteg, CurrentStegTypes, sporsmalHasCustomHeader } from './reducer/current-steg';
import { SporsmalsflytHeader } from './sporsmalsflyt-header';
import { Sporsmalsflytsteg } from './sporsmalsflytsteg';

interface Props {
    header: {
        title: string;
        subtitle?: string;
        svgCardType?: SvgCardType;
    };
    userHasFilledInInfo: boolean;
    currentSteg: CurrentSteg;
    Oppsummering: React.FC;
    skjemaside: Skjemaside;
    onPrev: () => void;
    retryFetchingData: () => void;
}

export const Sporsmalsflyt = ({
    header,
    userHasFilledInInfo,
    currentSteg,
    onPrev,
    skjemaside,
    retryFetchingData,
    Oppsummering,
}: Props) => {
    const showSubtitle =
        currentSteg.type === CurrentStegTypes.Sporsmal &&
        currentSteg.currentSporsmal.type !== SporsmalType.SporsmalSide;

    return (
        <>
            {userHasFilledInInfo && <Prompt />}
            {!sporsmalHasCustomHeader(currentSteg) && (
                <SporsmalsflytHeader
                    svgCardType={header.svgCardType}
                    title={header.title}
                    subtitle={header.subtitle}
                    showSubtitle={showSubtitle}
                />
            )}
            <Sporsmalsflytsteg
                currentSteg={currentSteg}
                Oppsummering={Oppsummering}
                onPrev={onPrev}
                retryFetchingData={retryFetchingData}
                skjemaside={skjemaside}
            />
            <SporreskjemaButton />
        </>
    );
};
